import { ACTIONS } from "app/store/actions"
import { IOrder, IOrderForm, IOrderList } from "order/model"
import { Action } from "redux"

export interface IOrderActionAddOrUpdate extends Action {
  order: IOrder
}

export interface IOrderActionSetList extends Action {
  list: Partial<IOrderList>
}

export interface IOrderActionOpenFormPopup extends Action {
  form: IOrderForm
}

export interface IOrderActionSetForm extends Action {
  form: Partial<IOrderForm>
}

export const orderActionCreator = {
  add(order: IOrder): IOrderActionAddOrUpdate {
    return {
      type: ACTIONS.ORDER_ADD,
      order
    }
  },
  update(order: IOrder): IOrderActionAddOrUpdate {
    return {
      type: ACTIONS.ORDER_UPDATE,
      order
    }
  },
  setList(list: Partial<IOrderList>): IOrderActionSetList {
    return {
      type: ACTIONS.ORDER_SET_LIST,
      list
    }
  },
  openFormPopup(form: IOrderForm): IOrderActionOpenFormPopup {
    return {
      type: ACTIONS.ORDER_OPEN_FORM_POPUP,
      form
    }
  },
  closeFormPopup(): Action {
    return {
      type: ACTIONS.ORDER_CLOSE_FORM_POPUP
    }
  },
  setForm(form: Partial<IOrderForm>): IOrderActionSetForm {
    return {
      type: ACTIONS.ORDER_SET_FORM,
      form
    }
  }
}
